import Mp4Video from "../classes/Mp4Video";
import YouTubeVideo from "../classes/YouTubeVideo";
import youTubeIframeLoader from 'youtube-iframe';

export default () => {

	const mp4Videos = document.querySelectorAll('.js-mp4-video');
	const youtubeVideos = document.querySelectorAll('.js-youtube-video');

	mp4Videos.forEach(el => new Mp4Video().init(el));

	if (youtubeVideos.length) {
		youTubeIframeLoader.load(function () {
			youtubeVideos.forEach(el => new YouTubeVideo().init(el));
		});
	}
}
